import { extension } from 'mime-types'

export function getFileExtension(file: File): string | false
export function getFileExtension(mimeType: string): string | false
export function getFileExtension(file: File | string): string | false {
  return extension(typeof file === 'string' ? file : file.type)
}
